import React from 'react';
import cn from 'classname';

import Cell from './cell';

const Row = props => {

	const { row, fetchExpandedData, intervals, affiliatesLoadingFromId } = props;
	const expanded_from_id = row.expanded_from_id;

	return (
		<tr className={cn({'narrow-row': !!expanded_from_id})}>
			<td className={cn({
				'fixed-col min-width-100 max-width-100': true,
				'padding-left-30': !expanded_from_id,
				'padding-left-40': !!expanded_from_id
			})}>
				{
					expanded_from_id
						? <p>
							<p>{row.affiliate_mail} ({row.affiliate_level})</p>
							<p className="word-break-all margin-top-15"><span>{JSON.stringify(row.affiliate_utms)}</span></p>
						</p>
						: <span>
							{row.utm_value || row.created_month} Affs: ({!!row.affiliate_ids && row.affiliate_ids.length})
						</span>
				}
				{!expanded_from_id &&
					<a
						className={cn({
							'hover-pointer position-relative top-4 left-4': true,
							'icon-details': affiliatesLoadingFromId !== row.row_id,
							'icon-details--loading': affiliatesLoadingFromId === row.row_id
						})}
						onClick={fetchExpandedData.bind(null, row)}
					/>
				}
			</td>
			{intervals.map((int, index) => <Cell key={index} row={row} interval={int} />)}
		</tr>
	);
};

export default Row;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/marketing-funnel/registration-activity/components/row.js